module.exports = __webpack_public_path__ + "img/tutorial.7f3976e5.webp";